<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="设备故障"
      edit-title
      id-key="FailureId"
      :data="data"
      :line-form="true"
      form-label-width="125px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="over"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="EquipmentName">
              <el-input v-model="data.EquipmentName" placeholder="请输入设备名称" @click.native="onManage" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备编号" prop="EquipmentName" class="notBottom">
              <span>{{ data.EquipmentNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="报障时间" prop="FailureTime">
              <el-date-picker v-model="data.FailureTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="故障类型" prop="FailureType">
              <el-select v-model="data.FailureType">
                <el-option v-for="item in failureTypes" :label="item.ClassName" :value="item.ClassId" :key="item.ClassId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="故障描述" prop="FailureRemark">
              <el-input type="textarea" v-model="data.FailureRemark" placeholder="请输入故障描述" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修开始时间">
              <el-date-picker v-model="data.RepairStartTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修结束时间">
              <el-date-picker v-model="data.RepairEndTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
          <el-col :span="12">
            <el-form-item label="维修结果" prop="RepariType">
              <el-select v-model="data.RepariType">
                <el-option value="1" label="已完成"></el-option>
                <el-option value="2" label="无法维修"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
      </template>
    </common-dialog>
    <manage-select ref="manageSelect" in-dialog selectable :multiple="multiple" @forselect="setManage"></manage-select>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import facilityDialog from '@/components/facility/manage/listDialog'
import manageSelect from '@/components/facility/manage/listDialog'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    facilityDialog,
    manageSelect
  },
  data() {
    return {
      data: {
        FailureId: 0,
        EquipmentId: 0,
        CreatedTime: '',
        Status: 1,
        AddUserId: 0,
        FailureTime: '',
        FailureRemark: '',
        RepairStartTime: '',
        RepairEndTime: '',
        FailureType: '',
        RepariType: '',
        EquipmentName: '',
        EquipmentNo: '',
        EmpName: ''
      },
      timmer: null,
      index: null,
      beforeChange: [],
      Mode: 1,
      facList: [],
      code_api: require('@/api/sy/serialCode').default,
      formApi: require('@/api/sy/formSetting').default,
      api: require('@/api/ba/equipmentFailure').default,
      classApi:require('@/api/ba/class').default,
      showList: [],
      rules: {
        EquipmentName: [{ required: true, message: '请输入设备名称' }],
        FailureTime: [{ required: true, message: '请选择报障时间' }],
        FailureRemark: [{ required: true, message: '请输入故障描述' }],
      },
      failureTypes:[],
      multiple:false
    }
  },
  mounted(){
    this.classApi.list({ClassType:18,Status:1}).then(res=>{
      this.failureTypes=res.Data;
    })
  },
  methods: {
    onManage() {
      this.$refs.manageSelect.open().then(that => {
        that.getData()
      })
    },
    setManage(data) {
      console.log(data,"setManage");
      this.data.EquipmentName = data.EquipmentName
      this.data.EquipmentId = data.EquipmentId
      this.data.EquipmentNo = data.EquipmentNo
    },
    onCreateOpened() {},
    onEditOpened(data) {
      this.api.info(data.FailureId).then(res => {
        this.data = res.Data
        this.data.FailureType=parseInt(this.data.FailureType);
      })
    },
    
    onBeforeSave() {
    
    },
    delRow() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delList = this.multipleSelection.map(item => item.DistrictId)
          let data = this.areaList.filter(item => !delList.includes(item.DistrictId))
          this.areaList = JSON.parse(JSON.stringify(data))
        })
        .catch(() => {})
    },
    over() {
      this.$refs.manageSelect.clear()
    }
  }
}
</script>
